import { useState, useEffect } from 'react'
import { Modal, ModalHeader, ModalBody, ModalFooter, Button } from 'reactstrap'
import { DatePicker, KeyValuePairs } from 'components/ideal-core-ui'
import s from './FollowupDateModal.scss'
import { timezoneDate, utcDate } from 'utils/helpers'

const FollowupDateModal = ({
  entity,
  toggleFollowupDateModal,
  showFollowupDateModal,
  onSave,
  cancelCb,
  title,
  entities
}) => {
  const [followUpDate, setFollowUpDate] = useState(null)

  useEffect(() => {
    setFollowUpDate(entity?.followUpDate || null)
  }, [entity])

  return (
    <Modal
      keyboard={false}
      backdrop="static"
      isOpen={showFollowupDateModal}
      toggle={toggleFollowupDateModal}
      size="md"
    >
      <ModalHeader toggle={cancelCb || toggleFollowupDateModal} className={s.modalHeader}>
        {`Set ${title} Follow-up Date`}
      </ModalHeader>
      <ModalBody>
        <div className={s.main}>
          <KeyValuePairs
            pairs={[
              {
                key: 'Select follow-up date:',
                value: (
                  <DatePicker
                    value={followUpDate ? timezoneDate(followUpDate) : ''}
                    onChange={value => {
                      const date = value ? utcDate(value) : ''
                      setFollowUpDate(date)
                    }}
                  />
                )
              }
            ]}
          />
        </div>
      </ModalBody>
      <ModalFooter>
        <Button
          disabled={!followUpDate}
          data-cy="followup-modal-save"
          className={s.saveBtn}
          onClick={e => {
            if (entities) {
              onSave(followUpDate, entities)
            } else {
              onSave(followUpDate, e, entity)
            }
            toggleFollowupDateModal()
          }}
        >
          Save
        </Button>
        <Button color="secondary" onClick={cancelCb || toggleFollowupDateModal}>
          Cancel
        </Button>
      </ModalFooter>
    </Modal>
  )
}

export default FollowupDateModal
